/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { Tooltip } from 'antd'
import colors from '@sportninja/common/constants/appColors'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import { FAMILY_SUPPORT_URL } from '@sportninja/common/features/profile/family/constants'
import QuestionIcon from 'src/components/icons/QuestionIcon'

interface FamilyGuideLinkProps {
  size?: number
}

/** Question mark beside a Family Members title; opens the guide in a new tab. */
const FamilyGuideLink = ({ size = 18 }: FamilyGuideLinkProps) => (
  // Portals out, so it needs to clear the full-screen modals it sits in.
  <Tooltip title={capitalizeWords('How Family Members Work')} zIndex={10050}>
    <a
      css={linkStyle}
      href={FAMILY_SUPPORT_URL}
      target='_blank'
      rel='noopener noreferrer'
      aria-label='Learn more about family members'
    >
      <QuestionIcon size={size} color={colors.PRIMARY} />
    </a>
  </Tooltip>
)

export default FamilyGuideLink

// ---- styled ----
const linkStyle = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  line-height: 0;

  &:hover {
    opacity: 0.85;
  }
`
